import { Smartphone, Bot, PackageOpen } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";

const icons = [Smartphone, Bot, PackageOpen];

export const HowItWorks = () => {
  const { t } = useLang();
  return (
    <section id="how" className="py-20 md:py-28 bg-white" data-testid="how-section">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <SectionHead label={t.how.label} title={t.how.title} center />
        <div className="grid md:grid-cols-3 gap-6">
          {t.how.steps.map((s, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={i} delay={i * 0.1}>
                <div className="card p-8 h-full hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(0,0,0,0.2)]" data-testid={`how-step-${i}`}>
                  <div className="flex items-center justify-between">
                    <span className="w-14 h-14 rounded-2xl bg-tricolor-green/10 text-tricolor-green flex items-center justify-center">
                      <Icon size={26} />
                    </span>
                    <span className="font-display font-extrabold text-5xl text-line">{s.n}</span>
                  </div>
                  <h3 className="mt-6 font-display font-bold text-xl md:text-2xl text-ink">{s.title}</h3>
                  <p className="mt-3 text-muted leading-relaxed">{s.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
